export const minLengthValidator = (length: number) => (value: string | undefined): undefined | string => {
  if (typeof value === 'string' && value.length < length) {
    return `Минимальная длина ${length}`;
  }

  return undefined;
};
